import { useCallback } from 'react';

export function useHomepageSettingsForm({ config, updateField, uploadImage, showToast }) {
  const ensureArray = useCallback((value) => (Array.isArray(value) ? value : []), []);

  const updateListItem = useCallback(
    (key, index, field, value) => {
      const current = ensureArray(config[key]);
      const next = current.map((item, i) => (i === index ? { ...item, [field]: value } : item));
      updateField(key, next);
    },
    [config, ensureArray, updateField]
  );

  const addListItem = useCallback(
    (key, item) => {
      const current = ensureArray(config[key]);
      updateField(key, [...current, item]);
    },
    [config, ensureArray, updateField]
  );

  const removeListItem = useCallback(
    (key, index) => {
      const current = ensureArray(config[key]);
      updateField(
        key,
        current.filter((_, i) => i !== index)
      );
    },
    [config, ensureArray, updateField]
  );

  const updatePrimitiveListItem = useCallback(
    (key, index, value) => {
      const current = ensureArray(config[key]);
      const next = current.map((item, i) => (i === index ? value : item));
      updateField(key, next);
    },
    [config, ensureArray, updateField]
  );

  const updateDestinationCardField = useCallback(
    (tabIndex, cardIndex, field, value) => {
      const tabs = ensureArray(config.destinationTabs);
      const next = tabs.map((entry, i) => {
        if (i !== tabIndex) return entry;
        return {
          ...entry,
          cards: ensureArray(entry.cards).map((c, ci) =>
            ci === cardIndex ? { ...c, [field]: value } : c
          ),
        };
      });
      updateField('destinationTabs', next);
    },
    [config.destinationTabs, ensureArray, updateField]
  );

  const handleImageUpload = useCallback(
    async (file, onUploaded) => {
      if (!file) return;
      try {
        const imageUrl = await uploadImage(file);
        if (imageUrl) {
          onUploaded(imageUrl);
          showToast('Image uploaded successfully', 'success');
        }
      } catch {
        // Error is surfaced by upload hook state.
      }
    },
    [uploadImage, showToast]
  );

  return {
    ensureArray,
    updateListItem,
    addListItem,
    removeListItem,
    updatePrimitiveListItem,
    updateDestinationCardField,
    handleImageUpload,
  };
}
